import yx from '../modules/yx.js'
export default [
    //pdf预览
    { path: '/yx/pdfViewer/:fileNo', name: 'pdfViewer', component: yx.pdfViewer, meta: { title: '' } },
] 